import React, { ReactNode } from 'react';
import { IonButton } from '@ionic/react';
import { PredefinedColors } from '@ionic/core';
import { createUseStyles } from 'react-jss';

type IStyleKeys = 'button';

interface IStyleProps {
    size?: 'small';
    color?: PredefinedColors
}

const useStyles = createUseStyles<IStyleKeys, IStyleProps>({
    button: {
        '--ion-color-base': ({color}) => `rgba(var(--ion-color-${color}-rgb), 0.2) !important`,
        '--padding-start': ({size}) => (size === 'small' ? '0px' : undefined),
        '--padding-end': ({size}) => (size === 'small' ? '0px' : undefined),
        '--padding-top': ({size}) => (size === 'small' ? '0px' : undefined),
        '--padding-bottom': ({size}) => (size === 'small' ? '0px' : undefined),
        width: ({size}) => (size === 'small' ? '36px !important' : undefined),
        height: ({size}) => (size === 'small' ? '36px !important' : undefined)
    }
});

interface IRoundButtonProps {
    size?: 'small';
    color?: PredefinedColors;
    target?: string;
    href?: string;
    onClick?: (e: React.MouseEvent) => void;
    children: ReactNode;
    fill?: 'clear' | 'solid';
    'data-id'?: string;
}

export const RoundButton: React.FC<IRoundButtonProps> = ({ size, color = 'medium', target, href, onClick, children, fill = 'solid', 'data-id': dataId }) => {

    const classes = useStyles({ size, color });

    return (
        <IonButton
            shape="round"
            fill={fill}
            color={color}
            target={target}
            href={href}
            onClick={onClick ? (e: React.MouseEvent) => onClick(e) : undefined}
            className={classes.button}
            data-id={dataId}
        >
            {children}
        </IonButton>
    );
};
